import axios from 'axios';
import { apiBaseUrl } from '../config.js';

export const verifyToken = async () => {
  const token = localStorage.getItem('userToken');
  if (!token) return false;

  try {
    // Send the token in the Authorization header as Bearer token
    const response = await axios.post(
      `${apiBaseUrl}/api/validate`,
      {}, // No need to send body content
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    // Check the server response
    if (response.status === 200 && response.data.valid) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
